// Valores por defecto de rulesIndicationsOfDanger.
export const defaultRulesIndicationsOfDangerSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultAction = () => {
    return "";
};

// Valor por defecto de ruleIndicationOfDanger.
export const defaultRuleIndicationOfDanger = () => {
    return {
        id: null,
        name: null,
        sga_danger_indication_code_combination_ids: [],
        sga_danger_indication_code_display_ids: [],
    };
};

// Valores por defecto de filterRulesIndicationsOfDanger.
export const defaultFilterRulesIndicationsOfDanger = () => {
    return {
        name: null,
        is_active: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

export default {
    rulesIndicationsOfDanger: defaultRulesIndicationsOfDangerSga(),
    action: defaultAction(),
    ruleIndicationOfDanger: defaultRuleIndicationOfDanger(),
    filterRulesIndicationsOfDanger: defaultFilterRulesIndicationsOfDanger(),
};
